const accountInformation = {
  methods: {
    async updateProfile(with_shipsurance) {
      this.$v.validationGroup.form.$touch();

      if (this.$v.validationGroup.form.$invalid) {
        this.$emit("alert", {
          message: "Unable to save update, Full name is required!",
          type: "danger"
        });
        return;
      }

      let vm = this;

      try{
        const res = await axios.post('/users/profile', this.form)

        vm.$emit('alert', {
          message: res.data.message,
          type: 'success'
        });
        // console.log("with_shipsurance: ", with_shipsurance? "true" : "false")

        if (with_shipsurance) {
          const { data } = await axios.post('/users/accept-shipsurance');
          if (data.status === 'error') {
            this.$emit("alert", {
              message: data.message,
              type: 'danger',
            });
            this.user.shipsurance_terms = 0;
          }
        }
      } catch (e) {
        console.error('Error', e);
        this.$emit("alert", {
          message: "Unable to save update!",
          type: "danger"
        });
      } finally {
        this.fetchInfo();
        this.refreshUser();
        if (with_shipsurance) {
          this.$refs.profileModal.hide()
        }
      }

      // axios
      //   .post('/users/profile', this.form)
      //   .then(function(response) {
      //     vm.$emit('alert', {
      //       message: response.data.message,
      //       type: 'success'
      //     });
      //   })
      //   .catch(function(error) {
      //     vm.$emit('alert', {
      //       message: error.response.data.message,
      //       type: 'danger'
      //     });
      //   })
      //   .finally(() => {
      //     this.fetchInfo();
      //     this.refreshUser();
      //   });
    },
    updatePassword(e) {
      this.$v.validationGroup.form2.$touch();

      if (this.$v.validationGroup.form2.$invalid) {
        return;
      }

      let vm = this;
      axios
        .post('/users/password', this.form2)
        .then(function(response) {
          vm.$emit('alert', {
            message: response.data.message,
            type: 'success'
          });
        })
        .catch(function(error) {
          vm.$emit('alert', {
            message: error.response.data.message,
            type: 'danger'
          });
        })
        .finally(() => {
          this.fetchInfo();
          this.refreshUser();
        });
    },
    updateEmail(e) {
      console.log('updating email');

      this.$v.validationGroup.form3.$touch();

      if (this.$v.validationGroup.form3.$invalid) {
        return;
      }

      let vm = this;
      axios
        .post('/users/email', this.form3)
        .then(function(response) {
          vm.$emit('alert', {
            message: response.data.message,
            type: 'success'
          });
        })
        .catch(function(error) {
          vm.$emit('alert', {
            message: error.response.data.message,
            type: 'danger'
          });
        })
        .finally(() => {
          this.fetchInfo();
          this.refreshUser();
        });
    }
  }
};

export default accountInformation;



// WEBPACK FOOTER //
// ./resources/assets/js/views/MyAccount/mixins/AccountInformation.js